(() => {
  "use strict";

  /* ---------- overlays (cart drawer / mobile nav / search / filter sheet) ---------- */
  function closeAll() {
    document.querySelectorAll(".x-overlay.is-open").forEach((el) => el.classList.remove("is-open"));
    document.documentElement.classList.remove("x-scroll-lock");
  }
  function open(el) {
    if (!el) return;
    closeAll();
    el.classList.add("is-open");
    document.documentElement.classList.add("x-scroll-lock");
    const focusable = el.querySelector("input, button, [href]");
    if (focusable) focusable.focus({ preventScroll: true });
  }

  document.addEventListener("click", (e) => {
    const openCart = e.target.closest("[data-open-cart]");
    if (openCart) { e.preventDefault(); open(document.querySelector("[data-cart-drawer]")); }

    const openNav = e.target.closest("[data-open-nav]");
    if (openNav) {
      e.preventDefault();
      // Always start collapsed - mirrors the design's closeSidebar(), which
      // resets collectionsOpen alongside sidebarOpen.
      const toggle = document.querySelector("[data-mnav-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      open(document.querySelector("[data-mobile-nav]"));
    }

    const openSearch = e.target.closest("[data-open-search]");
    if (openSearch) {
      e.preventDefault();
      const overlay = document.querySelector("[data-search-overlay]");
      open(overlay);
      const input = overlay && overlay.querySelector("[data-search-input]");
      const resultsHost = overlay && overlay.querySelector("[data-search-results]");
      // Rebuild rather than leave the server-rendered popular-only block -
      // this is also what picks up recent searches added since page load.
      if (resultsHost && (!input || !input.value.trim())) resultsHost.innerHTML = buildDefaultSearchState();
      if (input) setTimeout(() => input.focus(), 50);
    }

    if (e.target.closest("[data-close]") || e.target.closest("[data-dismiss]")) {
      e.preventDefault();
      closeAll();
    }

    const suggest = e.target.closest("[data-search-suggest]");
    if (suggest) {
      const input = document.querySelector("[data-search-overlay] [data-search-input]");
      if (input) { input.value = suggest.textContent.trim(); runPredictiveSearch(input.value); }
    }
  });

  // A search only counts as "recent" once it's actually submitted - not on
  // every predictive keystroke, which would fill the list with fragments.
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("[data-search-form]");
    if (!form) return;
    const input = form.querySelector("[data-search-input]");
    if (input && input.value.trim()) addRecentSearch(input.value.trim());
  });

  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });

  /* ---------- PLP: filters, sort, load-more, state restoration (§21, §27.3, §29.2) ----------
     Filters update through the Section Rendering API - no reload, no scroll jump.
     Without JS the form still submits normally, so the page degrades cleanly. */
  const plp = document.querySelector("[data-plp]");
  if (plp) {
    const form = plp.querySelector("[data-filter-form]");
    const results = plp.querySelector("[data-plp-results]");
    const sectionId = plp.getAttribute("data-section-id");
    const sheet = plp.querySelector("[data-filter-sheet]");
    const sheetBody = plp.querySelector("[data-filter-sheet-body]");
    const facets = plp.querySelector(".x-plp__facets-inline");
    const bar = plp.querySelector(".x-plp__bar-inner");
    const mqMobile = window.matchMedia("(max-width: 900px)");

    // One set of inputs, two homes: move the facets rather than cloning them,
    // so the form never carries duplicate field names.
    function placeFacets() {
      if (!facets || !sheetBody || !bar) return;
      const groups = facets.querySelectorAll("details");
      if (mqMobile.matches) {
        if (facets.parentElement !== sheetBody) sheetBody.appendChild(facets);
        // In the sheet every group is an always-open stack, not a dropdown
        groups.forEach((d) => { d.open = true; });
      } else {
        if (facets.parentElement !== bar) bar.insertBefore(facets, bar.querySelector(".x-plp__sort"));
        groups.forEach((d) => { d.open = false; });
      }
    }
    placeFacets();
    if (mqMobile.addEventListener) mqMobile.addEventListener("change", placeFacets);

    // Desktop: a click outside closes any open facet dropdown
    document.addEventListener("click", (e) => {
      if (mqMobile.matches) return;
      plp.querySelectorAll(".x-facet[open]").forEach((d) => {
        if (!d.contains(e.target)) d.open = false;
      });
    });

    function buildUrl(page) {
      const params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach((v, k) => { if (v !== "") params.append(k, v); });
      }
      if (page && page > 1) params.set("page", page);
      const qs = params.toString();
      return window.location.pathname + (qs ? "?" + qs : "");
    }

    function render(url, { append = false, push = true } = {}) {
      if (!results) return;
      results.classList.add("is-loading");
      const sep = url.indexOf("?") === -1 ? "?" : "&";
      return fetch(url + sep + "section_id=" + sectionId)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const fresh = doc.querySelector("[data-plp-results]");
          if (!fresh) return;

          if (append) {
            const freshGrid = fresh.querySelector(".x-grid");
            const grid = results.querySelector(".x-grid");
            if (freshGrid && grid) {
              Array.from(freshGrid.children).forEach((child) => grid.appendChild(child));
            }
            const oldMore = results.querySelector(".x-plp__more");
            const newMore = fresh.querySelector(".x-plp__more");
            if (oldMore) oldMore.remove();
            if (newMore) results.appendChild(newMore);
          } else {
            results.innerHTML = fresh.innerHTML;
          }

          // Live counts and active chips
          const freshCount = doc.querySelector("[data-plp-count]");
          const count = plp.querySelector("[data-plp-count]");
          if (freshCount && count) count.textContent = freshCount.textContent;
          const freshChips = doc.querySelector(".x-active-chips");
          const chips = plp.querySelector(".x-active-chips");
          if (chips && freshChips) chips.innerHTML = freshChips.innerHTML;
          else if (chips && !freshChips) chips.innerHTML = "";
          const applyBtn = plp.querySelector("[data-plp-apply]");
          if (applyBtn && freshCount) applyBtn.textContent = "Show " + freshCount.textContent;

          if (push) history.replaceState({ xplp: true }, "", url);
          if (window.xRevealScan) window.xRevealScan(results);
          autoBusy = false;
          watchAutoLoad();
        })
        .finally(() => {
          results.classList.remove("is-loading");
          // A failed fetch never reaches the then() above - without this the
          // busy flag would latch on and stop every later page from loading.
          autoBusy = false;
        });
    }

    /* §21 - pages load on scroll rather than from a Load more button. The
       section renders a sentinel after the last row whenever another page
       exists, and every appended page brings the next sentinel with it, so
       re-observing after each render is what keeps the chain going. */
    let autoObserver = null;
    let autoBusy = false;
    // Set while the back-navigation restore below replays pages itself, so the
    // observer doesn't race it and fetch the same page a second time.
    let autoPaused = false;
    function watchAutoLoad() {
      if (autoObserver) autoObserver.disconnect();
      const sentinel = plp.querySelector("[data-plp-auto]");
      if (!sentinel || !("IntersectionObserver" in window)) return;
      autoObserver = new IntersectionObserver((entries) => {
        if (autoBusy || autoPaused || !entries.some((en) => en.isIntersecting)) return;
        autoBusy = true;
        autoObserver.disconnect();
        const page = parseInt(sentinel.getAttribute("data-page"), 10) || 1;
        // Kept in sync so the §29.2 back-navigation restore below still knows
        // how many extra pages to re-fetch.
        plp.setAttribute("data-more-clicks", (parseInt(plp.getAttribute("data-more-clicks"), 10) || 0) + 1);
        render(buildUrl(page + 1), { append: true });
        // 600px ahead of the fold, so the next row is there before it's reached.
      }, { rootMargin: "600px 0px" });
      autoObserver.observe(sentinel);
    }
    watchAutoLoad();

    if (form) {
      form.addEventListener("change", (e) => {
        if (!e.target.matches("input, select")) return;
        render(buildUrl());
      });
      form.addEventListener("submit", (e) => { e.preventDefault(); render(buildUrl()); });
    }

    // Active-filter chips and Clear all stay AJAX too
    plp.addEventListener("click", (e) => {
      const remove = e.target.closest("[data-filter-remove]");
      if (remove) {
        e.preventDefault();
        const url = remove.getAttribute("href");
        render(url);
        // Reflect the removal back into the form so buildUrl() stays in sync
        const params = new URLSearchParams(url.split("?")[1] || "");
        if (form) {
          form.querySelectorAll('input[type="checkbox"]').forEach((cb) => {
            cb.checked = params.getAll(cb.name).indexOf(cb.value) !== -1;
          });
          form.querySelectorAll('input[type="number"]').forEach((n) => {
            n.value = params.get(n.name) || "";
          });
        }
        return;
      }

      if (e.target.closest("[data-open-filters]") && sheet) {
        sheet.classList.add("is-open");
        document.documentElement.classList.add("x-scroll-lock");
      }
      if (e.target.closest("[data-close-filters]") && sheet) {
        sheet.classList.remove("is-open");
        document.documentElement.classList.remove("x-scroll-lock");
      }
    });

    /* §29.2 - back from a PDP restores scroll, filters and the loaded count */
    const stateKey = "x-plp-" + window.location.pathname;
    window.addEventListener("pagehide", () => {
      try {
        sessionStorage.setItem(stateKey, JSON.stringify({
          y: window.scrollY,
          url: window.location.pathname + window.location.search,
          clicks: plp.getAttribute("data-more-clicks") || 0,
        }));
      } catch (err) {}
    });
    window.addEventListener("pageshow", (e) => {
      if (!e.persisted && !performance.getEntriesByType("navigation").some((n) => n.type === "back_forward")) return;
      try {
        const saved = JSON.parse(sessionStorage.getItem(stateKey) || "null");
        if (!saved) return;
        const restore = () => window.scrollTo(0, saved.y);
        if (parseInt(saved.clicks, 10) > 0) {
          autoPaused = true;
          let chain = Promise.resolve();
          for (let i = 2; i <= parseInt(saved.clicks, 10) + 1; i++) {
            const p = i;
            chain = chain.then(() => render(buildUrl(p), { append: true, push: false }));
          }
          chain.then(() => { restore(); autoPaused = false; watchAutoLoad(); });
        } else {
          restore();
        }
      } catch (err) {}
    });
  }

  /* Re-measures the header's real bottom edge into --x-header-now. Assigned
     by the header block below; declared here so anything that changes the
     header's height can force a fresh measurement. No-op until then. */
  let syncHeaderMetrics = () => {};

  /* ---------- announcement bar dismiss ---------- */
  const announceClose = document.querySelector("[data-announce-close]");
  if (announceClose) {
    if (sessionStorage.getItem("x-announce-dismissed")) {
      document.querySelector("[data-header]").setAttribute("data-announce-dismissed", "");
    }
    announceClose.addEventListener("click", () => {
      document.querySelector("[data-header]").setAttribute("data-announce-dismissed", "");
      sessionStorage.setItem("x-announce-dismissed", "1");
      // Dismissing removes the 38px announcement strip, so the header's
      // bottom edge moves. Without this, --x-header-now stays 38px too low
      // until the next scroll or resize.
      syncHeaderMetrics();
    });
  }

  /* ---------- header measurement + compact state (§18.4) ----------
     The header is a permanent floating island (sections/header.liquid
     Change 3) - is-scrolled no longer toggles its SHAPE, only its SIZE.
     Past a small scroll threshold the pill compacts (shorter row, tighter
     gaps, smaller wordmark); scrolling back to the top eases it back to
     full size. Same rAF-throttled handler also writes the bar's REAL
     current bottom edge to --x-header-now on :root every scroll/resize
     frame, so the mega-panel and the sticky PLP/PDP/cart bars read "just
     under the header" instead of each hand-reconstructing its height.
     Runs once immediately so a bfcache restore or a deep link landing
     mid-scroll doesn't leave the header un-measured or wrongly sized. */
  const header = document.querySelector("[data-header]");
  if (header) {
    const bar = header.querySelector(".x-header__bar");
    let scrollTicking = false;
    let isScrolled = null;
    let settleRaf = 0;

    /* --x-header-now lives on :root, so every write invalidates the style of
       every element in the document that reads a custom property - and the
       getBoundingClientRect() that feeds it forces a synchronous layout.
       Doing both on all ~60 frames of a continuous scroll is the single
       biggest scroll cost on the page, and it is almost always wasted: the
       bar's bottom edge is CONSTANT while scrolling, and only moves during
       the 520ms is-scrolled morph, on resize, and on announce-bar dismiss.
       So the value is cached and the property is only written when the
       measurement actually changed. */
    let lastBottom = -1;
    syncHeaderMetrics = () => {
      if (!bar) return;
      const bottom = Math.round(bar.getBoundingClientRect().bottom);
      if (bottom === lastBottom) return;
      lastBottom = bottom;
      document.documentElement.style.setProperty("--x-header-now", bottom + "px");
    };

    /* Keep measuring for the WHOLE morph, not just the frame the class
       flipped. Scroll events stop firing the moment the user stops
       scrolling, but the 520ms size transition has only just STARTED at
       that point - so the last scroll-driven measurement captured the
       header mid-morph and then froze there. Scrolling back to the top was
       the worst case: the final measurement was taken with the bar still
       compact AND (on the homepage) the announcement bar still slid off,
       leaving --x-header-now ~100px shorter than the header's real settled
       height. The mega-panel reads that variable for its `top`, so it
       opened well inside the navbar instead of below it. Driving the
       measurement off rAF for the transition's duration means the variable
       tracks the bar to its true resting edge every time. */
    const trackSettle = () => {
      cancelAnimationFrame(settleRaf);
      const raw = parseFloat(getComputedStyle(header).getPropertyValue("--x-dur-header"));
      // Explicit isFinite, not `|| 520`: reduced-motion sets this to 0ms and
      // 0 is falsy, which would wrongly fall back to the full duration.
      const dur = Number.isFinite(raw) ? raw : 520;
      let started = null;
      const step = (now) => {
        if (started === null) started = now;
        syncHeaderMetrics();
        // Small tail past the declared duration so the final settled frame
        // is always measured, never the second-to-last one.
        if (now - started < dur + 80) settleRaf = requestAnimationFrame(step);
      };
      settleRaf = requestAnimationFrame(step);
    };

    /* The scroll path reads window.scrollY and NOTHING else - no layout
       read, no style write - unless the compact state actually flips. When
       it does, trackSettle() takes over and re-measures every frame for the
       duration of the morph, which is the only window in which the header's
       bottom edge is actually moving. */
    const applyScrollState = () => {
      // Only touch the class list when the state actually flips - no
      // redundant class attribute write on every one of the ~60 scroll
      // frames a continuous scroll produces.
      const scrolled = window.scrollY > 24;
      if (scrolled !== isScrolled) {
        isScrolled = scrolled;
        header.classList.toggle("is-scrolled", scrolled);
        trackSettle();
      }
      scrollTicking = false;
    };
    const onScroll = () => {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(applyScrollState);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    /* Resize is debounced separately. iOS fires a burst of resize events as
       its URL bar collapses mid-scroll; measuring synchronously on each one
       used to interleave a forced layout with the scroll itself. */
    let headerResizeTimer;
    window.addEventListener(
      "resize",
      () => {
        clearTimeout(headerResizeTimer);
        headerResizeTimer = setTimeout(() => {
          syncHeaderMetrics();
          onScroll();
        }, 120);
      },
      { passive: true }
    );
    applyScrollState();
    syncHeaderMetrics();
  }

  /* ---------- announcement bar: rotate 4 claims every 5s, pause on hover (§19 S1) ---------- */
  const announce = document.querySelector("[data-announce-rotate]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (announce && !reduceMotion) {
    const claims = announce.querySelectorAll(".x-announce__claim");
    if (claims.length > 1) {
      let cur = 0;
      let paused = false;
      announce.addEventListener("mouseenter", () => (paused = true));
      announce.addEventListener("mouseleave", () => (paused = false));
      setInterval(() => {
        if (paused || document.hidden) return;
        claims[cur].classList.remove("is-current");
        cur = (cur + 1) % claims.length;
        claims[cur].classList.add("is-current");
      }, 5000);
    }
  }

  /* ---------- Collections mega-panel (§18.4): hover intent, close delay, keyboard, touch ---------- */
  document.querySelectorAll("[data-mega-wrap]").forEach((wrap) => {
    const trigger = wrap.querySelector("[data-mega-trigger]");
    const panel = wrap.querySelector("[data-mega]");
    if (!trigger || !panel) return;
    let openTimer, closeTimer;
    const isOpen = () => !panel.hidden;
    const setOpen = (open) => {
      // Measure the header's real bottom edge immediately BEFORE unhiding,
      // so the panel's very first painted frame is positioned against the
      // header's current geometry. The rAF settle tracker above keeps
      // --x-header-now honest through the scroll morph; this guarantees it
      // regardless of how the header got to its current size (font reflow,
      // editor re-render, a state change with no scroll or resize event).
      // The panel is `position: fixed` with `top: var(--x-header-now) + 8px`
      // - it can only ever sit below the bar if that value is current.
      if (open) syncHeaderMetrics();
      panel.hidden = !open;
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    };

    const finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (finePointer) {
      wrap.addEventListener("mouseenter", () => {
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => setOpen(true), 120);
      });
      wrap.addEventListener("mouseleave", () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => setOpen(false), 240);
      });
    } else {
      // Touch: first tap opens, second tap on the label navigates
      trigger.addEventListener("click", (e) => {
        if (!isOpen()) {
          e.preventDefault();
          setOpen(true);
        }
      });
      document.addEventListener("click", (e) => {
        if (isOpen() && !wrap.contains(e.target)) setOpen(false);
      });
    }

    trigger.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown" || ((e.key === "Enter" || e.key === " ") && !isOpen())) {
        e.preventDefault();
        setOpen(true);
        const first = panel.querySelector("a");
        if (first) first.focus();
      }
    });
    wrap.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && isOpen()) {
        setOpen(false);
        trigger.focus();
      }
    });
    wrap.addEventListener("focusout", (e) => {
      if (!wrap.contains(e.relatedTarget)) setOpen(false);
    });
  });

  /* ---------- Account menu: hover-intent dropdown on the header profile icon (desktop only) ---------- */
  // Login / Track order. Same hover-intent timings as the mega panel above.
  // The panel is position:fixed (the header bar is overflow:hidden), so its
  // top/right - and the notch's offset, --x-acct-notch - come from the icon's
  // live rect, re-read every frame while open so it follows the header's
  // scroll morph instead of freezing wherever the icon was when it opened.
  document.querySelectorAll("[data-account-wrap]").forEach((wrap) => {
    const trigger = wrap.querySelector("[data-account-trigger]");
    const panel = wrap.querySelector("[data-account-menu]");
    if (!trigger || !panel) return;
    const desktop = window.matchMedia("(min-width: 1024px) and (hover: hover) and (pointer: fine)");
    let openTimer, closeTimer, raf = 0, last = "";
    const isOpen = () => !panel.hidden;

    const place = () => {
      const r = trigger.getBoundingClientRect();
      const viewW = document.documentElement.clientWidth;
      const right = Math.max(12, viewW - r.right - 10);
      const top = Math.round(r.bottom + 12);
      // Notch centre = icon centre. Its `right` is measured from the panel's
      // padding edge (1px in from the border) and it is 12px wide, hence -7.
      const notch = Math.round(viewW - right - (r.left + r.width / 2) - 7);
      const key = top + "/" + right + "/" + notch;
      if (key === last) return;
      last = key;
      panel.style.top = top + "px";
      panel.style.right = right + "px";
      panel.style.setProperty("--x-acct-notch", notch + "px");
    };
    const track = () => { place(); raf = requestAnimationFrame(track); };

    const setOpen = (open) => {
      if (open && (!desktop.matches || isOpen())) return;
      if (!open && !isOpen()) return;
      cancelAnimationFrame(raf);
      if (open) {
        last = "";
        place(); // before unhiding, so the first painted frame is already in place
        track();
      }
      panel.hidden = !open;
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    };

    wrap.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => setOpen(true), 120);
    });
    wrap.addEventListener("mouseleave", () => {
      clearTimeout(openTimer);
      closeTimer = setTimeout(() => setOpen(false), 240);
    });
    // Keyboard: tabbing onto the icon opens it, and the next Tab stop is the
    // first row (the panel follows the icon in the DOM).
    wrap.addEventListener("focusin", () => {
      if (trigger.matches(":focus-visible") || panel.contains(document.activeElement)) {
        clearTimeout(closeTimer);
        setOpen(true);
      }
    });
    wrap.addEventListener("focusout", (e) => {
      if (!wrap.contains(e.relatedTarget)) setOpen(false);
    });
    wrap.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && isOpen()) {
        setOpen(false);
        trigger.focus();
      }
    });
    // Leaving desktop (window resized narrow) - close rather than strand it.
    desktop.addEventListener("change", (e) => { if (!e.matches) setOpen(false); });
  });

  /* ---------- mobile drawer: Collections accordion (§18.5) ---------- */
  const mnavToggle = document.querySelector("[data-mnav-toggle]");
  if (mnavToggle) {
    mnavToggle.addEventListener("click", () => {
      const open = mnavToggle.getAttribute("aria-expanded") === "true";
      mnavToggle.setAttribute("aria-expanded", open ? "false" : "true");
    });
  }

  /* ---------- Growth Rings click feedback (§13.6) + Sawdust (§13.7) ---------- */
  function emitRings(btn, x, y) {
    if (reduceMotion) return;
    if (getComputedStyle(btn).position === "static") btn.style.position = "relative";
    const host = document.createElement("span");
    host.className = "x-rings";
    host.style.left = x + "px";
    host.style.top = y + "px";
    host.innerHTML = "<span></span><span></span><span></span>";
    btn.appendChild(host);
    setTimeout(() => host.remove(), 800);
  }
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".x-btn--primary, .x-btn--engrave, .x-btn--ghost, .x-icon-btn, .x-chip--age");
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    emitRings(btn, e.clientX ? e.clientX - rect.left : rect.width / 2, e.clientY ? e.clientY - rect.top : rect.height / 2);
  });

  function emitSawdust(btn) {
    if (reduceMotion || sessionStorage.getItem("x-sawdust-done")) return;
    sessionStorage.setItem("x-sawdust-done", "1");
    if (getComputedStyle(btn).position === "static") btn.style.position = "relative";
    const host = document.createElement("span");
    host.className = "x-sawdust";
    for (let i = 0; i < 8; i++) {
      const m = document.createElement("span");
      m.style.setProperty("--dx", (Math.random() * 60 - 30).toFixed(0) + "px");
      m.style.setProperty("--dy", (-30 - Math.random() * 40).toFixed(0) + "px");
      m.style.animationDelay = (Math.random() * 120).toFixed(0) + "ms";
      host.appendChild(m);
    }
    btn.appendChild(host);
    setTimeout(() => host.remove(), 1100);
  }
  window.xSawdust = emitSawdust;

  /* ---------- Engrave Draw-On driver (§13.4) ---------- */
  function engraveBurn(fx, text) {
    const t = fx.querySelector(".x-engrave-fx__text");
    if (!t) return;
    if (text != null) t.textContent = text;
    fx.classList.remove("is-burning", "is-typing");
    void fx.offsetWidth; // restart animations
    fx.style.setProperty("--x-fx-run", (t.offsetWidth + 4) + "px");
    if (reduceMotion) return; // final text is already in the DOM
    fx.classList.add("is-burning");
  }
  function engraveType(fx, text) {
    // Lightweight mode while typing (§13.4 MUST): text updates instantly,
    // only the ember pulses at the newest character.
    const t = fx.querySelector(".x-engrave-fx__text");
    if (!t) return;
    t.textContent = text;
    fx.classList.remove("is-burning", "is-typing");
    if (reduceMotion) return;
    void fx.offsetWidth;
    fx.style.setProperty("--x-fx-run", (t.offsetWidth + 4) + "px");
    fx.classList.add("is-typing");
  }
  window.xEngraveBurn = engraveBurn;
  window.xEngraveType = engraveType;

  // "A name on it" loop - runs once, on first reveal (§19 S5)
  document.querySelectorAll("[data-engrave-loop]").forEach((fx) => {
    const names = fx.getAttribute("data-engrave-loop").split(",");
    if (!names.length || !("IntersectionObserver" in window)) return;
    let started = false;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting && !started) {
          started = true;
          io.disconnect();
          let i = 0;
          engraveBurn(fx, names[0]);
          const iv = setInterval(() => {
            i++;
            if (i >= names.length) { clearInterval(iv); return; }
            engraveBurn(fx, names[i]);
          }, 2000);
        }
      });
    }, { threshold: 0.3 });
    io.observe(fx);
  });

  /* ---------- toast ---------- */
  function toast(msg, undoFn, actionLabel) {
    const region = document.querySelector("[data-toast-region]");
    if (!region) return;
    region.innerHTML = "";
    const el = document.createElement("div");
    el.className = "x-toast";
    el.setAttribute("role", "status");
    el.innerHTML = `<span style="flex:1;font-size:14px;line-height:1.45"></span>`;
    el.querySelector("span").textContent = msg;
    if (undoFn) {
      const btn = document.createElement("button");
      btn.textContent = actionLabel || "Undo";
      btn.style.cssText = "flex:none;font-size:14px;font-weight:600;color:var(--x-honey);text-decoration:underline;text-underline-offset:.14em";
      btn.addEventListener("click", () => { undoFn(); region.innerHTML = ""; });
      el.appendChild(btn);
    }
    region.appendChild(el);
    setTimeout(() => { if (region.contains(el)) region.innerHTML = ""; }, undoFn ? 6000 : 3200);
  }
  window.xToast = toast;

  /* ---------- bestseller rail: drag-to-scroll + auto-scroll (§15.1) ---------- */
  document.querySelectorAll("[data-rail]").forEach((rail) => {
    const viewport = rail.querySelector("[data-rail-viewport]");
    const track = rail.querySelector("[data-rail-track]");
    const section = rail.closest(".x-rail-section");
    if (!viewport || !track || !section) return;

    const autoplay = !reduceMotion && !section.classList.contains("x-rail--manual") && !(window.XS && window.XS.carouselAutoplay === false);

    // Doubled track: wrap the scroll position at the halfway point so the
    // loop (and free dragging past either end) feels infinite either way.
    let half = 0;
    let pxPerSec = 0;
    const measure = () => {
      half = track.scrollWidth / 2;
      // Derived here rather than once at startup: the track's width is only
      // final after the card images have laid out, and it changes again on
      // every breakpoint switch (160px cards to 280px).
      const speedSec = parseFloat(getComputedStyle(track).getPropertyValue("--x-rail-speed")) || 3.4;
      const count = parseFloat(getComputedStyle(track).getPropertyValue("--x-rail-count")) || (track.children.length / 2) || 1;
      pxPerSec = half / (speedSec * count);
    };
    measure();
    // A resize listener that measures synchronously runs a forced layout on
    // every one of the resize events iOS fires while its URL bar collapses.
    let measureTimer;
    window.addEventListener("resize", () => {
      clearTimeout(measureTimer);
      measureTimer = setTimeout(measure, 150);
    });
    window.addEventListener("load", measure);
    const wrap = () => {
      if (half <= 0) return;
      if (viewport.scrollLeft >= half) viewport.scrollLeft -= half;
      else if (viewport.scrollLeft <= 0) viewport.scrollLeft += half;
    };

    // Mouse/pen drag-to-scroll - touch already scrolls natively.
    let dragging = false, dragged = false, startX = 0, startScroll = 0;
    viewport.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "touch") return;
      dragging = true; dragged = false;
      startX = e.clientX; startScroll = viewport.scrollLeft;
      viewport.classList.add("is-dragging");
      e.preventDefault();
    });
    viewport.addEventListener("pointermove", (e) => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3 && !dragged) {
        // Capture only once a real drag starts - capturing on every
        // pointerdown retargets click to the viewport (an ancestor of the
        // card link), so the browser's hyperlink walk never reaches the
        // <a> and plain clicks stop navigating entirely.
        dragged = true;
        viewport.setPointerCapture(e.pointerId);
      }
      viewport.scrollLeft = startScroll - dx;
      wrap();
    });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove("is-dragging");
      if (dragged) {
        const swallowClick = (e) => { e.preventDefault(); e.stopPropagation(); };
        viewport.addEventListener("click", swallowClick, { capture: true, once: true });
      }
    };
    viewport.addEventListener("pointerup", endDrag);
    viewport.addEventListener("pointercancel", endDrag);

    if (!autoplay) return;

    // Pause on hover, focus, drag, and when off-screen - never fight the shopper.
    let hovered = false, onscreen = true;
    rail.addEventListener("mouseenter", () => { hovered = true; });
    rail.addEventListener("mouseleave", () => { hovered = false; });
    rail.addEventListener("focusin", () => { hovered = true; });
    rail.addEventListener("focusout", () => { hovered = false; });
    rail.addEventListener("touchstart", () => { hovered = true; }, { passive: true });
    rail.addEventListener("touchend", () => { setTimeout(() => { hovered = false; }, 2500); }, { passive: true });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          onscreen = en.isIntersecting;
          // Not just a flag check inside the loop: the loop itself is torn
          // down when the rail leaves the viewport. A marquee that keeps
          // requesting frames while off-screen still forces a scrollLeft
          // layout read and a scroll-offset write on every frame of the
          // page's own scroll, which is exactly the work that makes a long
          // page feel heavy on mobile.
          if (onscreen) startLoop(); else stopLoop();
        });
      }, { threshold: 0.05 }).observe(rail);
    }

    // Same reasoning for a backgrounded tab - rAF is already throttled there,
    // but a hidden tab has no reason to hold an animation frame callback.
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stopLoop();
      else if (onscreen) startLoop();
    });

    // The scroll offset is tracked here as a float instead of being read back
    // out of scrollLeft each frame. WebKit truncates scrollLeft to whole
    // pixels on write (12.6 reads back as 12; Blink rounds instead), so a
    // read-modify-write loop throws away the sub-pixel remainder on every
    // frame. At this rail's ~46px/sec that step is ~0.38px on a 120Hz iPhone -
    // truncated straight back to the integer it started from, leaving the rail
    // motionless. Keeping the true position in JS means the remainder carries
    // across frames and only the rendered offset quantises.
    let pos = viewport.scrollLeft;
    let lastWritten = pos;
    let lastTs;
    let raf = 0;
    const tick = (ts) => {
      if (lastTs == null) lastTs = ts;
      // A backgrounded tab resumes with a huge gap; capped so the rail never
      // teleports on return.
      const dt = Math.min((ts - lastTs) / 1000, 0.05);
      lastTs = ts;
      if (!hovered && !dragging && onscreen && half > 0) {
        // Native touch momentum and the scrollbar move scrollLeft behind our
        // back - when it no longer matches what we wrote, the shopper moved it.
        if (Math.abs(viewport.scrollLeft - lastWritten) > 1.5) pos = viewport.scrollLeft;
        pos += pxPerSec * dt;
        if (pos >= half) pos -= half;
        else if (pos <= 0) pos += half;
        viewport.scrollLeft = pos;
        lastWritten = viewport.scrollLeft;
      }
      raf = requestAnimationFrame(tick);
    };
    function startLoop() {
      if (raf) return;
      lastTs = null; // never bill the paused interval to the next frame's dt
      raf = requestAnimationFrame(tick);
    }
    function stopLoop() {
      if (!raf) return;
      cancelAnimationFrame(raf);
      raf = 0;
    }
    startLoop();
  });

  /* ---------- cart: ajax add / change / refresh ---------- */
  // Both requests below can transiently fail (a Shopify edge/backend blip, not
  // just a network drop). Without checking r.ok and catching, a failure here
  // used to be completely silent: the item was added server-side, but the
  // drawer never opened and the header count never updated, so the customer
  // saw no sign the add-to-cart worked at all. Now it always ends in either
  // an updated cart or a visible toast telling them what to do next.

  // Bumped once per refreshCart() call and closed over by each request's own
  // `seq`. If a newer refresh starts before an older one's section HTML comes
  // back, the older one's DOM write is skipped - otherwise clicking + twice
  // quickly could let the first (slower) response land last and flash the
  // drawer back to a stale quantity.
  let cartRequestSeq = 0;
  let lastCartCount = (() => {
    const el = document.querySelector("[data-cart-count]");
    return el ? parseInt(el.textContent, 10) || 0 : 0;
  })();

  function updateHeaderCount(cart) {
    // Engraving charges ride in the cart as their own lines, so item_count
    // counts an engraved board twice. The badge counts pieces a shopper
    // recognises - same rule as the snippets/cart-count.liquid render.
    const cfg = engraveConfig();
    const shownCount = cfg
      ? cart.items.reduce((n, i) => (isFeeLine(i, cfg) ? n : n + i.quantity), 0)
      : cart.item_count;
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = shownCount;
      el.hidden = cart.item_count === 0;
    });
    if (cart.item_count > lastCartCount) {
      document.querySelectorAll(".x-cart-btn").forEach((btn) => {
        btn.classList.remove("is-bumping");
        void btn.offsetWidth; // restart the animation if one is still playing
        btn.classList.add("is-bumping");
        btn.addEventListener("animationend", () => btn.classList.remove("is-bumping"), { once: true });
      });
    }
    lastCartCount = cart.item_count;
  }

  function refreshDrawerSection(seq) {
    return fetch(window.location.pathname + "?section_id=cart-drawer")
      .then((r) => {
        if (!r.ok) throw new Error("cart-drawer section fetch failed: " + r.status);
        return r.text();
      })
      .then((html) => {
        if (seq !== cartRequestSeq) return; // superseded by a later change - drop this render
        const doc = new DOMParser().parseFromString(html, "text/html");
        const fresh = doc.querySelector("[data-cart-drawer]");
        const current = document.querySelector("[data-cart-drawer]");
        if (fresh && current) {
          // Swap content in place rather than replacing the whole node: a
          // replaceWith() removes/reinserts the panel, which restarts its
          // slide-in animation - from an already-open drawer (e.g. a quick-add
          // in "Goes well with") that reads as the drawer closing and
          // reopening. Updating innerHTML keeps the same panel element alive,
          // so its entrance animation never replays and open/scroll state
          // (like is-open) is untouched.
          const freshPanel = fresh.querySelector(".x-overlay__panel");
          const currentPanel = current.querySelector(".x-overlay__panel");
          if (freshPanel && currentPanel) {
            currentPanel.innerHTML = freshPanel.innerHTML;
            current.toggleAttribute("data-has-items", fresh.hasAttribute("data-has-items"));
          } else {
            const wasOpen = current.classList.contains("is-open");
            fresh.classList.toggle("is-open", wasOpen);
            current.replaceWith(fresh);
          }
        }
      });
  }

  // `knownCart` lets a caller that already has the fresh cart JSON (e.g.
  // /cart/change.js returns the full updated cart) skip a redundant /cart.js
  // round trip entirely. Previously every change did three network calls
  // back to back (change.js, then the section fetch, then cart.js) - that
  // serial chain was the main source of the 1-2s lag. Now the section fetch
  // and the cart-count update run in parallel, and the header count applies
  // the instant `knownCart` arrives rather than waiting on the section HTML.
  function refreshCart(afterFn, knownCart) {
    const seq = ++cartRequestSeq;
    const cartPromise = knownCart
      ? Promise.resolve(knownCart)
      : fetch("/cart.js").then((r) => {
          if (!r.ok) throw new Error("cart.js fetch failed: " + r.status);
          return r.json();
        });

    cartPromise.then((cart) => { if (seq === cartRequestSeq) updateHeaderCount(cart); }).catch(() => {});

    return Promise.all([refreshDrawerSection(seq), cartPromise])
      .then(([, cart]) => {
        if (afterFn) afterFn(cart);
      })
      .catch(() => {
        toast("Your cart was updated, but the preview couldn't load.", () => {
          window.location.href = "/cart";
        }, "View cart");
      });
  }

  // FormData keeps bracket-notation field names ("properties[Engraving Text]")
  // as literal flat keys - it doesn't nest them the way a server-side form
  // parser would. /cart/add.js only recognises a real nested `properties`
  // object, so this always has to be built explicitly; sending the raw flat
  // fd silently drops every property Shopify can't match, which is what made
  // typed engraving text/notes vanish. Shared by the Add to cart submit and
  // the Order Now (Cash on Delivery) button so both add identical line items.
  function cartItemsFromForm(form) {
    const engraveBox = form.querySelector("[data-engrave-toggle]");
    const engraveVariant = form.querySelector("[data-engrave-variant]");
    const fd = Object.fromEntries(new FormData(form).entries());

    const properties = {};
    Object.keys(fd).forEach((k) => {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m) properties[m[1]] = fd[k];
    });

    const quantity = parseInt(fd.quantity || "1", 10);
    const wantsEngraving = !!(engraveBox && engraveBox.checked && engraveVariant && engraveVariant.value);
    // Text typed before the toggle was switched back off stays in the field
    // (and the browser restores it on reload), so without this the line ships
    // engraving instructions that nothing was charged for.
    if (!wantsEngraving) {
      Object.keys(properties).forEach((k) => {
        if (k.indexOf("Engraving") === 0) delete properties[k];
      });
    }
    if (wantsEngraving) properties[ENGRAVE_ID_KEY] = newEngraveId();
    const items = [{ id: fd.id, quantity, properties }];
    if (wantsEngraving) {
      const link = {};
      link[ENGRAVE_FOR_KEY] = properties[ENGRAVE_ID_KEY];
      items.push({ id: engraveVariant.value, quantity, properties: link });
    }
    return items;
  }

  /* ---------- engraving: keep each fee line welded to its product ---------- */
  // The engraving charge is its own cart line (a real product variant), so by
  // default a shopper can delete it or re-quantity it on its own and keep the
  // engraved item - engraving done, nothing paid. Every engraved line is
  // stamped with a hidden `_engrave_id` and its fee line with a matching
  // `_engrave_for`, which is what lets the pair be found again and repaired.
  // Underscore-prefixed properties are hidden from customer-facing cart and
  // order displays and can't be set from any input a shopper can reach.
  const ENGRAVE_ID_KEY = "_engrave_id";
  const ENGRAVE_FOR_KEY = "_engrave_for";

  function newEngraveId() {
    return "e" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  // Rendered onto the cart drawer, which is on every page, so the fee variant
  // is reachable from the PDP, the cart page and the drawer alike.
  function engraveConfig() {
    const el = document.querySelector("[data-engrave-fee-variant]");
    if (!el) return null;
    const variantId = parseInt(el.getAttribute("data-engrave-fee-variant"), 10);
    if (!variantId) return null;
    return { variantId: variantId, handle: el.getAttribute("data-engrave-fee-handle") || "" };
  }

  function engraveProp(item, key) {
    return (item.properties && item.properties[key]) || null;
  }

  function isFeeLine(item, cfg) {
    return (!!cfg.handle && item.handle === cfg.handle) || item.variant_id === cfg.variantId;
  }

  function isEngravedLine(item) {
    if (!item.properties) return false;
    return Object.keys(item.properties).some(
      (k) => k.indexOf("Engraving") === 0 && item.properties[k]
    );
  }

  // Works out what it would take to make every fee line agree with the
  // engraved line it belongs to. Three repairs: a fee quantity that drifted
  // from its product's, a fee line whose product is gone, and an engraved
  // product whose fee line was deleted. Lines added before the `_engrave_id`
  // stamp existed carry no key, so they reconcile as a single pool instead.
  function engraveRepairs(cart) {
    const ops = [];
    const adds = [];
    const cfg = engraveConfig();
    if (!cfg || !cart || !cart.items) return { ops: ops, adds: adds };

    const wantById = {};
    cart.items.forEach((item) => {
      const id = engraveProp(item, ENGRAVE_ID_KEY);
      if (id) wantById[id] = (wantById[id] || 0) + item.quantity;
    });

    const feesById = {};
    cart.items.forEach((item) => {
      const forId = engraveProp(item, ENGRAVE_FOR_KEY);
      if (forId) (feesById[forId] = feesById[forId] || []).push(item);
    });

    Object.keys(feesById).forEach((id) => {
      const want = wantById[id] || 0;
      // Only the first line of a pair carries the quantity - a duplicate can
      // appear if an add is retried, and two half-quantities would still add
      // up while reading as two separate charges in the cart.
      feesById[id].forEach((fee, i) => {
        const target = i === 0 ? want : 0;
        if (fee.quantity !== target) ops.push({ key: fee.key, quantity: target });
      });
    });

    Object.keys(wantById).forEach((id) => {
      if (feesById[id]) return;
      const link = {};
      link[ENGRAVE_FOR_KEY] = id;
      adds.push({ id: cfg.variantId, quantity: wantById[id], properties: link });
    });

    const legacyFees = cart.items.filter(
      (i) => isFeeLine(i, cfg) && !engraveProp(i, ENGRAVE_FOR_KEY)
    );
    const legacyWant = cart.items
      .filter((i) => !isFeeLine(i, cfg) && !engraveProp(i, ENGRAVE_ID_KEY) && isEngravedLine(i))
      .reduce((n, i) => n + i.quantity, 0);
    if (legacyFees.length) {
      legacyFees.forEach((fee, i) => {
        const target = i === 0 ? legacyWant : 0;
        if (fee.quantity !== target) ops.push({ key: fee.key, quantity: target });
      });
    } else if (legacyWant > 0) {
      adds.push({ id: cfg.variantId, quantity: legacyWant });
    }

    return { ops: ops, adds: adds };
  }

  let engraveSyncing = false;

  // Resolves with `{cart, changed}`: the repaired cart when something was off,
  // the cart it was handed when nothing needed doing. Never rejects - a failed
  // repair falls back to the cart as-is rather than trapping a shopper.
  function syncEngravingDetailed(cart) {
    const plan = engraveSyncing ? { ops: [], adds: [] } : engraveRepairs(cart);
    if (!plan.ops.length && !plan.adds.length) {
      return Promise.resolve({ cart: cart, changed: false });
    }

    engraveSyncing = true;
    let chain = Promise.resolve(cart);
    // Sequential, not parallel: each /cart/change.js call is resolved against
    // the cart as it stands, and two in flight at once can clobber each other.
    plan.ops.forEach((op) => {
      chain = chain.then(() =>
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: op.key, quantity: op.quantity }),
        }).then((r) => r.json())
      );
    });
    if (plan.adds.length) {
      chain = chain
        .then(() =>
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ items: plan.adds }),
          })
        )
        // add.js answers with the added items, not the whole cart.
        .then(() => fetch("/cart.js").then((r) => r.json()));
    }

    return chain
      .then((fresh) => ({ cart: fresh && fresh.items ? fresh : cart, changed: true }))
      .catch(() => ({ cart: cart, changed: false }))
      .then((result) => {
        engraveSyncing = false;
        return result;
      });
  }

  function syncEngraving(cart) {
    return syncEngravingDetailed(cart).then((r) => r.cart);
  }

  function syncEngravingFromServer() {
    return fetch("/cart.js")
      .then((r) => r.json())
      .then(syncEngravingDetailed)
      .catch(() => ({ cart: null, changed: false }));
  }

  // The PDP Add to cart button carries an icon alongside its label (the
  // Order Now button sits next to it and needs the same visual weight), so
  // its text lives in a `.x-pdp__atc-label` span - setting textContent on
  // the button directly would wipe the icon out. Older text-only buttons
  // (the mobile sticky bar) have no such span and just take textContent.
  function setBtnLabel(btn, text) {
    const label = btn.querySelector(".x-pdp__atc-label");
    if (label) label.textContent = text;
    else btn.textContent = text;
  }

  // Shared by the PDP/drawer product forms and by the product card's quick-add
  // button, which can't use a form at all: a card on a collection page sits
  // inside the filter form, and the HTML parser drops a nested <form>, leaving
  // its button wired to the filter instead of the cart.
  function addItemsToCart(items, submitBtn) {
    if (submitBtn) submitBtn.disabled = true;

    const body = { items: items };

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((res) => {
        if (submitBtn) submitBtn.disabled = false;
        if (res.status) { toast(res.description || "Couldn't add that to your cart."); return; }
        if (submitBtn && window.xSawdust) window.xSawdust(submitBtn);
        // Confirmation on the button itself, not only in the drawer: the
        // drawer can be dismissed or slow, and the customer's eye is here.
        if (submitBtn && submitBtn.hasAttribute("data-add-to-cart")) {
          const restore = submitBtn.getAttribute("data-label-idle") || submitBtn.textContent.trim();
          submitBtn.setAttribute("data-label-idle", restore);
          submitBtn.classList.add("is-added");
          setBtnLabel(submitBtn, "Added ✓");
          clearTimeout(submitBtn._addedT);
          submitBtn._addedT = setTimeout(() => {
            submitBtn.classList.remove("is-added");
            setBtnLabel(submitBtn, restore);
          }, 1800);
        }
        // Only drive the open() animation when the drawer is closed (e.g. an
        // add-to-cart from the PDP). If it's already open - a quick-add from
        // inside the drawer's own "Goes well with" row - open() would still
        // run closeAll()+add, toggling is-open off/on and restarting the
        // slide-in for no reason.
        const drawerEl = document.querySelector("[data-cart-drawer]");
        const alreadyOpen = drawerEl && drawerEl.classList.contains("is-open");
        refreshCart(alreadyOpen ? undefined : () => open(drawerEl));
      })
      .catch(() => {
        // A non-JSON response lands here (a transient Shopify error page rather
        // than the {status, description} error body cart/add.js returns for a
        // normal decline). Previously this reset the button with no message at
        // all, so a failed add looked identical to a successful one that just
        // didn't animate.
        if (submitBtn) submitBtn.disabled = false;
        toast("Couldn't add that to your cart. Please try again.");
      });
  }

  document.addEventListener("submit", (e) => {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    addItemsToCart(cartItemsFromForm(form), form.querySelector('[type="submit"]'));
  });

  /* ---------- PDP: restyle + reposition EasySell's Cash on Delivery button ---------- */
  // The EasySell COD app injects #es-popup-button as a sibling of our
  // [data-add-to-cart] button, inside that button's own theme-block wrapper -
  // so it's boxed into the Add to cart column's width instead of spanning
  // the full buy box like the design calls for. Moving it into
  // .x-pdp__buy-stack (a DOM move preserves EasySell's click handlers) puts
  // it on its own full-width row below quantity + Add to cart. Its colors
  // are also set as inline `style="... !important"` from its own script -
  // a plain stylesheet !important can never win against an inline
  // !important, so this overwrites the inline style directly, re-applied on
  // every mutation since EasySell repaints it (variant change, sold-out
  // state). Colors come from the CSS custom properties blocks/buy-buttons.
  // liquid sets on :root from its "Cash on Delivery button style" setting,
  // so this stays in sync with the theme editor. Fragile by nature: coupled
  // to EasySell's current element ids/classes and insertion point, and
  // silently stops matching if the app changes its markup.
  (function () {
    const pdpRoot = document.querySelector(".x-pdp");
    const buyStack = pdpRoot && pdpRoot.querySelector(".x-pdp__buy-stack");
    if (!pdpRoot || !buyStack) return;

    const ES_BG = "var(--x-buybuttons-ordernow-bg, var(--x-ink))";
    const ES_BG_HOVER = "var(--x-buybuttons-ordernow-bg-hover, var(--x-terracotta-hover))";
    const ES_BG_PRESS = "var(--x-buybuttons-ordernow-bg-press, var(--x-terracotta-press))";

    const OBSERVE_OPTS = { childList: true, subtree: true, attributes: true, attributeFilter: ["style"] };
    let observer = null;

    // Every write below mutates the `style` attribute this module's own
    // MutationObserver watches, and observer callbacks run as microtasks - so
    // a write made while observing re-enters the callback, which writes again,
    // and the microtask queue never drains. The browser gets no chance to lay
    // out or paint, which is why the page rendered blank. Detaching for the
    // duration of our own writes is what keeps that loop from forming.
    function mutateSilently(fn) {
      if (observer) observer.disconnect();
      try {
        fn();
      } finally {
        if (observer) observer.observe(pdpRoot, OBSERVE_OPTS);
      }
    }

    function setEasySellBg(el, value) {
      mutateSilently(() => el.style.setProperty("background", value, "important"));
    }

    function themeEasySellButton(el) {
      el.style.setProperty("background", ES_BG, "important");
      el.style.setProperty("color", "var(--x-buybuttons-ordernow-fg, var(--x-cream))", "important");
      el.style.setProperty("border-radius", "var(--x-r-sm)", "important");
      el.style.setProperty("border-width", "0px", "important");
      el.style.setProperty("height", "46px", "important");
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("font-family", "var(--x-font-body)", "important");
      const title = el.querySelector(".es-button-title");
      if (title) title.style.setProperty("color", "var(--x-buybuttons-ordernow-fg, var(--x-cream))", "important");

      // §14.1 Grain Sweep's background darken on hover/press - a stylesheet
      // :hover can't win against the inline !important above, so it's done
      // here instead, same as the rest of this button's styling.
      if (!el.dataset.xHoverBound) {
        el.dataset.xHoverBound = "1";
        el.addEventListener("mouseenter", () => setEasySellBg(el, ES_BG_HOVER));
        el.addEventListener("mouseleave", () => setEasySellBg(el, ES_BG));
        el.addEventListener("mousedown", () => setEasySellBg(el, ES_BG_PRESS));
        el.addEventListener("mouseup", () => setEasySellBg(el, ES_BG_HOVER));
      }
    }

    function relocatePopupButton(el) {
      if (el.parentElement !== buyStack) buyStack.appendChild(el);
    }

    // #es-sticky (EasySell's own sticky bottom bar) is hidden outright via
    // CSS below rather than themed - the design's sticky bar is .x-sticky-atc.
    function findAndTheme(root) {
      const popup = root.id === "es-popup-button" ? root : root.querySelector && root.querySelector("#es-popup-button");
      if (popup) {
        mutateSilently(() => {
          themeEasySellButton(popup);
          relocatePopupButton(popup);
        });
      }
    }

    observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          findAndTheme(node);
        });
        if (m.type === "attributes" && m.target.id === "es-popup-button") {
          mutateSilently(() => themeEasySellButton(m.target));
        }
      });
    });

    findAndTheme(pdpRoot);
    observer.observe(pdpRoot, OBSERVE_OPTS);
  })();

  /* ---------- Cart drawer: restyle EasySell's Order Now button to match the checkout button ---------- */
  // Same fragile-by-nature approach as the PDP watcher above (EasySell sets
  // its own colors as inline `!important` styles, so only another inline
  // `!important` write can win) - here the target look is simply "identical
  // to .x-drawer__checkout" rather than a themed color, so it reads the same
  // --x-drawer-checkout-* custom properties cart-drawer.liquid already sets
  // from the section's own checkout button settings.
  (function () {
    const drawerRoot = document.querySelector("[data-cart-drawer]");
    const foot = drawerRoot && drawerRoot.querySelector(".x-drawer__foot");
    if (!drawerRoot || !foot) return;

    const OBSERVE_OPTS = { childList: true, subtree: true, attributes: true, attributeFilter: ["style"] };
    let observer = null;

    function mutateSilently(fn) {
      if (observer) observer.disconnect();
      try {
        fn();
      } finally {
        if (observer) observer.observe(drawerRoot, OBSERVE_OPTS);
      }
    }

    function themeEasySellButton(el) {
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("height", "var(--x-drawer-checkout-h, 52px)", "important");
      el.style.setProperty("font-size", "var(--x-drawer-checkout-fs, 15px)", "important");
      el.style.setProperty("background", "var(--x-drawer-checkout-bg, var(--x-terracotta-deep))", "important");
      el.style.setProperty("color", "var(--x-drawer-checkout-fg, var(--x-cream))", "important");
      el.style.setProperty("border-width", "var(--x-drawer-checkout-border-w, 0px)", "important");
      el.style.setProperty("border-style", "solid", "important");
      el.style.setProperty("border-color", "var(--x-drawer-checkout-border-color, transparent)", "important");
      el.style.setProperty("border-radius", "var(--x-drawer-checkout-radius, var(--x-r-md))", "important");
      el.style.setProperty("font-family", "var(--x-font-body)", "important");
      const title = el.querySelector(".es-button-title");
      if (title) title.style.setProperty("color", "var(--x-drawer-checkout-fg, var(--x-cream))", "important");
    }

    // Upsell rows hide EasySell's button outright via CSS (see cart-drawer.
    // liquid's `.x-drawer__upsell-row [id^="es-"]` rule) - only the copy
    // planted in the footer, above the checkout form, should be themed here.
    function findAndTheme(root) {
      const popup = root.id === "es-popup-button" ? root : root.querySelector && root.querySelector("#es-popup-button");
      if (popup && foot.contains(popup)) {
        mutateSilently(() => themeEasySellButton(popup));
      }
    }

    observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          findAndTheme(node);
        });
        if (m.type === "attributes" && m.target.id === "es-popup-button" && foot.contains(m.target)) {
          mutateSilently(() => themeEasySellButton(m.target));
        }
      });
    });

    findAndTheme(drawerRoot);
    observer.observe(drawerRoot, OBSERVE_OPTS);
  })();

  document.addEventListener("click", (e) => {
    const dec = e.target.closest("[data-qty-decrease]");
    const inc = e.target.closest("[data-qty-increase]");
    const remove = e.target.closest("[data-cart-remove]");
    const control = e.target.closest("[data-cart-line]");
    if (!control) return;
    const key = control.getAttribute("data-line-key");

    if (remove) {
      const title = control.querySelector(".x-line__title");
      const name = title ? title.textContent.trim() : "Item";
      control.classList.add("is-removing");

      // §28.4 - undo beats confirm. The snapshot is read from /cart.js rather
      // than the DOM so it carries every property verbatim, including the
      // hidden engraving key and the paired fee line. Restoring from the DOM
      // alone used to bring an engraved product back without its charge.
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => {
          const line = cart.items.filter((i) => i.key === key)[0];
          if (!line) return [];
          const items = [
            { id: line.variant_id, quantity: line.quantity, properties: line.properties || {} },
          ];
          const id = engraveProp(line, ENGRAVE_ID_KEY);
          if (id) {
            cart.items
              .filter((i) => engraveProp(i, ENGRAVE_FOR_KEY) === id)
              .forEach((fee) => {
                items.push({ id: fee.variant_id, quantity: fee.quantity, properties: fee.properties || {} });
              });
          }
          return items;
        })
        .catch(() => [])
        .then((snapshot) => {
          changeLine(key, 0, () => {
            toast("Removed " + name, () => {
              if (!snapshot.length) { refreshCart(); return; }
              fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ items: snapshot }),
              })
                .then((r) => r.json())
                .then(() => refreshCart())
                .catch(() => toast("Couldn't undo that removal. Please try again."));
            });
          });
        });
      return;
    }

    if (e.target.closest("[data-engrave-remove]")) {
      // Dropping the engraving has to take the charge and the instructions
      // together, or the warehouse engraves an item nobody paid to engrave.
      e.preventDefault();
      const feeKey = control.getAttribute("data-engrave-fee-key");
      removeEngraving(key, feeKey);
      return;
    }
    if (dec || inc) {
      const valEl = control.querySelector("[data-qty-value]");
      let qty = parseInt(valEl.textContent, 10) || 1;
      qty = inc ? qty + 1 : Math.max(0, qty - 1);
      // Show the new number the instant it's clicked instead of waiting on
      // the network round trip - the line price/subtotal/shipping bar catch
      // up moments later when the real cart data lands.
      valEl.textContent = qty;
      changeLine(key, qty);
    }
  });

  function changeLine(key, quantity, afterFn) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then((r) => r.json())
      // A product's quantity moving (or the line going away) is exactly what
      // leaves its engraving fee out of step, so repair before rendering.
      .then((cart) => syncEngraving(cart))
      // /cart/change.js already responds with the full updated cart - reuse
      // it instead of making refreshCart fetch /cart.js all over again.
      .then((cart) => refreshCart(afterFn, cart))
      .catch(() => toast("Couldn't update your cart. Please try again."));
  }

  // Takes the fee line out and the engraving instructions off the product in
  // one action. /cart/change.js merges properties rather than replacing them,
  // so there is no way to strip a property off a line in place - the product
  // is re-added as a clean line instead. The clean line goes in FIRST: if that
  // add fails, nothing has been taken away yet and the cart is untouched.
  function removeEngraving(parentKey, feeKey) {
    fetch("/cart.js")
      .then((r) => r.json())
      .then((cart) => {
        const line = cart.items.filter((i) => i.key === parentKey)[0];
        if (!line) return null;
        const kept = {};
        Object.keys(line.properties || {}).forEach((k) => {
          if (k.indexOf("Engraving") === 0 || k === ENGRAVE_ID_KEY) return;
          kept[k] = line.properties[k];
        });
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: line.variant_id, quantity: line.quantity, properties: kept }] }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) throw new Error(res.description || "add failed");
            return dropLines([parentKey, feeKey]);
          });
      })
      .then((cart) => {
        if (!cart) return;
        refreshCart(undefined, cart);
        if (document.querySelector("[data-cart-page]")) refreshCartPageSection();
      })
      .catch(() => toast("Couldn't remove that engraving. Please try again."));
  }

  // Sequential on purpose: two /cart/change.js calls in flight at once resolve
  // against the same starting cart and the second undoes the first.
  function dropLines(keys) {
    let chain = Promise.resolve(null);
    keys.filter(Boolean).forEach((key) => {
      chain = chain.then(() =>
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).then((r) => r.json())
      );
    });
    return chain;
  }

  // The cart page is server-rendered, so a repair or an engraving removal made
  // over fetch has to pull fresh section HTML - nothing else would redraw the
  // line, its totals or the rewards bar.
  function refreshCartPageSection() {
    const current = document.querySelector("[data-cart-page]");
    if (!current) return Promise.resolve();
    return fetch(window.location.pathname + "?section_id=main")
      .then((r) => {
        if (!r.ok) throw new Error("cart section fetch failed: " + r.status);
        return r.text();
      })
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-page]");
        const live = document.querySelector("[data-cart-page]");
        if (fresh && live) {
          live.replaceWith(fresh);
          if (window.xRevealScan) window.xRevealScan(fresh);
        }
      })
      .catch(() => window.location.reload());
  }

  // Repair on arrival. A cart tampered with through the console, a native cart
  // form submit that moved a product's quantity, or a cart left over from
  // before any of this existed all land here and are put right before the
  // shopper reads a total.
  (() => {
    const onCartPage = !!document.querySelector("[data-cart-page]");
    syncEngravingFromServer().then((result) => {
      if (!result.changed) return;
      if (onCartPage) refreshCartPageSection();
      else if (result.cart) refreshCart(undefined, result.cart);
    });
  })();

  document.addEventListener("click", (e) => {
    if (!e.target.closest("[data-open-cart]")) return;
    syncEngravingFromServer().then((result) => {
      if (result.changed && result.cart) refreshCart(undefined, result.cart);
    });
  });

  // Last gate before money changes hands: whatever state the cart drifted into,
  // it is reconciled and only then handed to checkout.
  document.addEventListener(
    "submit",
    (e) => {
      const submitter = e.submitter;
      if (!submitter || submitter.name !== "checkout") return;
      const form = e.target;
      if (form.dataset.engraveChecked === "1") return;
      e.preventDefault();
      submitter.disabled = true;
      syncEngravingFromServer().then(() => {
        form.dataset.engraveChecked = "1";
        submitter.disabled = false;
        // requestSubmit carries the submitter, which is what keeps the
        // prepaid-discount formaction and the `checkout` name on the request.
        if (form.requestSubmit) {
          form.requestSubmit(submitter);
        } else {
          const action = submitter.getAttribute("formaction");
          if (action) form.setAttribute("action", action);
          form.submit();
        }
      });
    },
    true
  );

  /* ---------- predictive search ---------- */
  let searchTimer;
  const POPULAR_SEARCHES = ["Cat wall bed", "Dog house", "Lacing toy", "Height chart", "Desk organiser", "Chai tray"];
  const RECENT_SEARCHES_KEY = "xs_recent_searches";

  function getRecentSearches() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }
  function addRecentSearch(term) {
    try {
      const list = getRecentSearches().filter((t) => t.toLowerCase() !== term.toLowerCase());
      list.unshift(term);
      localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(list.slice(0, 5)));
    } catch (e) {
      /* private browsing / storage disabled - recent searches just won't persist */
    }
  }
  // asLinks: the overlay's chips run a live predictive search in place, but
  // the full /search page has no predictive host to fill - its chips must
  // navigate directly instead.
  function buildDefaultSearchState(asLinks) {
    const chip = (term) =>
      asLinks
        ? `<a class="x-chip" href="/search?q=${encodeURIComponent(term)}&type=product">${escapeHtml(term)}</a>`
        : `<button type="button" class="x-chip" data-search-suggest>${escapeHtml(term)}</button>`;
    const recent = getRecentSearches();
    let html = "";
    if (recent.length) {
      html += `<div class="x-search-full__popular"><span class="x-search-full__label">Recent searches</span><div class="x-search-full__chips">${recent.map(chip).join("")}</div></div>`;
    }
    html += `<div class="x-search-full__popular"><span class="x-search-full__label">Popular searches</span><div class="x-search-full__chips">${POPULAR_SEARCHES.map(chip).join("")}</div></div>`;
    return html;
  }
  function runPredictiveSearch(q) {
    const resultsHost = document.querySelector("[data-search-results]");
    if (!resultsHost) return;
    if (!q || q.length < 2) {
      resultsHost.innerHTML = buildDefaultSearchState();
      return;
    }
    fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`)
      .then((r) => r.json())
      .then((data) => {
        const results = (data.resources && data.resources.results) || {};
        const products = results.products || [];
        const collections = results.collections || [];
        if (!products.length && !collections.length) {
          resultsHost.innerHTML = `
            <div style="padding:4px 18px 16px;font-size:15px;color:var(--x-ink-70)">No matches for "${escapeHtml(q)}". Try one of these:</div>
            ${buildDefaultSearchState()}`;
          return;
        }
        let html = "";
        if (collections.length) {
          html += `<div class="x-search-full__popular"><span class="x-search-full__label">Collections</span><div class="x-search-full__chips">${collections
            .slice(0, 4)
            .map((c) => `<a class="x-chip" href="${c.url}">${escapeHtml(c.title)}</a>`)
            .join("")}</div></div>`;
        }
        if (products.length) {
          const rows = products
            .map(
              (p) => `
            <a class="x-search-result" href="${p.url}">
              <span class="x-search-result__img">${p.featured_image ? `<img src="${p.featured_image.url}" alt="">` : ""}</span>
              <span class="x-search-result__body">
                <span class="x-search-result__title">${escapeHtml(p.title)}</span>
                <span class="x-search-result__meta">${escapeHtml(p.vendor || "")}</span>
              </span>
              <span class="x-search-result__price">${p.price}</span>
            </a>`
            )
            .join("");
          html += `<div>${rows}</div>`;
        }
        html += `<a class="x-search-seeall" href="/search?q=${encodeURIComponent(q)}&type=product">See all results</a>`;
        resultsHost.innerHTML = html;
      });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  }

  /* ---------- full search page: same suggestions when idle or empty ---------- */
  document.addEventListener("DOMContentLoaded", () => {
    const host = document.querySelector("[data-search-page-suggest]");
    if (!host) return;
    const performed = host.dataset.performed === "true";
    const count = parseInt(host.dataset.resultsCount, 10) || 0;
    if (!performed || count === 0) host.innerHTML = buildDefaultSearchState(true);
  });
  document.addEventListener("input", (e) => {
    if (!e.target.matches("[data-search-input]")) return;
    clearTimeout(searchTimer);
    const val = e.target.value.trim();
    searchTimer = setTimeout(() => runPredictiveSearch(val), 220);
  });

  /* ---------- generic single-select group (pick-one cards, e.g. a process rail) ---------- */
  document.querySelectorAll("[data-select-group]").forEach((group) => {
    const items = group.querySelectorAll("[data-select]");
    items.forEach((item) => {
      item.addEventListener("click", () => {
        items.forEach((i) => i.classList.toggle("is-active", i === item));
      });
    });
  });

  /* ---------- generic tab filter (home "room/occasion" rail, etc.) ---------- */
  document.querySelectorAll("[data-tab-group]").forEach((group) => {
    const buttons = group.querySelectorAll("[data-tab]");
    const targetSel = group.getAttribute("data-tab-group");
    const items = document.querySelectorAll(`[data-tab-target="${targetSel}"] [data-tab-item]`);
    const countEl = group.querySelector("[data-tab-count]");
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        buttons.forEach((b) => b.setAttribute("aria-selected", b === btn ? "true" : "false"));
        const val = btn.getAttribute("data-tab");
        let shownCount = 0;
        items.forEach((item) => {
          const show = val === "all" || item.getAttribute("data-tab-item") === val;
          item.style.display = show ? "" : "none";
          if (show) shownCount++;
        });
        if (countEl) {
          const singular = countEl.getAttribute("data-tab-count-singular") || "result";
          const plural = countEl.getAttribute("data-tab-count-plural") || `${singular}s`;
          countEl.textContent = `${shownCount} ${shownCount === 1 ? singular : plural}`;
        }
      });
    });
  });

  /* ---------- engraving: opt-in toggle + live preview (§22.4) ---------- */
  document.querySelectorAll("[data-engrave-toggle]").forEach((toggle) => {
    toggle.addEventListener("change", () => {
      const panel = document.querySelector("[data-engrave-panel]");
      if (!panel) return;
      // Radio pair (`yes`/`no`) or a plain checkbox both resolve to one boolean
      const on = toggle.type === "radio" ? toggle.value === "yes" : toggle.checked;
      panel.hidden = !on;
      // The PDP card's switch is a labelled checkbox, so its face has to say
      // what the next click does rather than what the state currently is.
      const face = document.querySelector("[data-engrave-switch-label]");
      if (face) face.textContent = on ? "Close" : face.getAttribute("data-off-label") || "Personalise +Free";
      if (on) {
        const input = panel.querySelector("[data-engrave-input]");
        if (input) input.focus({ preventScroll: true });
      }
    });
  });

  const ENGRAVE_OK = /[^A-Za-z0-9 &.]/g;
  document.querySelectorAll("[data-engrave-scope]").forEach((scope) => {
    const input = scope.querySelector("[data-engrave-input]");
    const fx = scope.querySelector(".x-engrave-fx");
    const textEl = scope.querySelector("[data-engrave-text]");
    const counter = scope.querySelector("[data-engrave-counter]");
    const errEl = scope.querySelector("[data-engrave-error]");
    const confirmEl = scope.querySelector("[data-engrave-confirm]");
    const confirmName = scope.querySelector("[data-engrave-confirm-name]");
    if (!input || !fx || !textEl) return;

    const max = parseInt(scope.getAttribute("data-engrave-max"), 10) || 12;
    const placeholder = textEl.textContent;
    const storeKey = "x-engrave-" + scope.getAttribute("data-engrave-scope");

    function render(raw, typing) {
      const cleaned = raw.replace(ENGRAVE_OK, "").slice(0, max);
      if (cleaned !== raw) {
        input.value = cleaned;
        if (errEl) {
          errEl.textContent = raw.length > max ? max + " characters maximum" : "Letters, numbers, spaces, & and . only";
          errEl.hidden = false;
        }
      } else if (errEl) {
        errEl.hidden = true;
      }
      if (counter) {
        counter.textContent = cleaned.length + "/" + max;
        counter.classList.toggle("is-max", cleaned.length >= max);
      }
      const shown = cleaned.length ? cleaned.toUpperCase() : placeholder;
      fx.classList.toggle("is-empty", cleaned.length === 0);
      if (confirmEl) {
        confirmEl.hidden = cleaned.length === 0;
        if (confirmName) confirmName.textContent = shown;
      }
      if (typing && window.xEngraveType) window.xEngraveType(fx, shown);
      else if (window.xEngraveBurn) window.xEngraveBurn(fx, shown);
      else textEl.textContent = shown;
      return cleaned;
    }

    // §29.2 - a typed name must survive back-navigation
    try {
      const saved = sessionStorage.getItem(storeKey);
      if (saved) { input.value = saved; render(saved, false); }
    } catch (e) {}

    input.addEventListener("input", () => {
      const cleaned = render(input.value, true);
      try { sessionStorage.setItem(storeKey, cleaned); } catch (e) {}
    });

    // Full three-layer Draw-On once, on first reveal (§13.4) - skipped when a
    // typewriter loop owns this instance instead (it drives its own reveal).
    if ("IntersectionObserver" in window && !scope.closest("[data-engrave-typewriter]")) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          io.disconnect();
          if (window.xEngraveBurn) window.xEngraveBurn(fx, textEl.textContent);
        });
      }, { threshold: 0.4 });
      io.observe(scope);
    }
  });

  /* ---------- Engrave typewriter loop - types/erases a demo name on repeat
     until the visitor types their own (then stops for good) ---------- */
  document.querySelectorAll("[data-engrave-typewriter]").forEach((scope) => {
    const demoName = scope.getAttribute("data-engrave-typewriter");
    const fx = scope.querySelector(".x-engrave-fx");
    const input = scope.querySelector("[data-engrave-input]");
    if (!demoName || !fx || !window.xEngraveType || reduceMotion) return;

    let typed = "", phase = "typing", userEdited = false, timer;
    function tick() {
      if (userEdited) return;
      let next = typed, ph = phase, delay = 150;
      if (phase === "typing") {
        if (typed.length < demoName.length) next = demoName.slice(0, typed.length + 1);
        else { ph = "hold"; delay = 1800; }
      } else if (phase === "hold") {
        ph = "erasing"; delay = 70;
      } else if (typed.length > 0) {
        next = typed.slice(0, -1); delay = 65;
      } else {
        ph = "typing"; delay = 600;
      }
      typed = next; phase = ph;
      window.xEngraveType(fx, typed);
      timer = setTimeout(tick, delay);
    }

    if (input) {
      input.addEventListener("input", () => { userEdited = true; clearTimeout(timer); }, { once: true });
    }
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { io.disconnect(); tick(); } });
      }, { threshold: 0.3 });
      io.observe(scope);
    } else {
      tick();
    }
  });

  /* ---------- PDP: accordion (one row open at a time) ----------
     A button + grid-rows panel rather than <details>, because <details> can't
     animate open - the 0fr→1fr transition on .x-acc__panel is what makes an
     unknown-height body slide instead of snap. */
  document.querySelectorAll("[data-acc]").forEach((group) => {
    const heads = Array.from(group.querySelectorAll("[data-acc-head]"));
    heads.forEach((head) => {
      head.addEventListener("click", () => {
        const panel = head.parentElement.querySelector("[data-acc-panel]");
        if (!panel) return;
        const willOpen = head.getAttribute("aria-expanded") !== "true";
        heads.forEach((h) => {
          const p = h.parentElement.querySelector("[data-acc-panel]");
          h.setAttribute("aria-expanded", "false");
          if (p) p.classList.remove("is-open");
        });
        head.setAttribute("aria-expanded", willOpen ? "true" : "false");
        panel.classList.toggle("is-open", willOpen);
      });
    });
  });

  /* ---------- PDP: gallery thumbs ---------- */
  // `play` is only true when a person picked the slide themselves (a thumb
  // click), never on a variant-driven swap - a video that starts itself
  // because a size swatch changed is startling, not helpful.
  function activateGalleryIndex(idx, play) {
    const main = document.querySelector("[data-gallery-main]");
    if (main) {
      main.querySelectorAll("[data-index]").forEach((slide) => {
        const on = slide.getAttribute("data-index") === String(idx);
        slide.classList.toggle("is-active", on);
        // A slide that scrolls out of view keeps playing otherwise - it is only
        // faded out, never unmounted. Native video pauses; a YouTube/Vimeo
        // iframe has no reachable API here, so its src is re-set to stop it.
        if (!on) {
          slide.querySelectorAll("video").forEach((v) => v.pause());
          slide.querySelectorAll("iframe").forEach((f) => {
            if (f.src) f.src = f.src;
          });
        }
      });
      if (play) playGallerySlide(main.querySelector(`[data-index="${idx}"]`));
    }
    document.querySelectorAll("[data-gallery-thumb]").forEach((t) => {
      const on = t.getAttribute("data-gallery-thumb") === String(idx);
      t.classList.toggle("is-active", on);
      // A variant can point at a slide whose thumb sits past the "+N" cap and
      // is still hidden - reveal it so the active thumb is never invisible.
      if (on) t.removeAttribute("hidden");
    });
  }

  // Start whatever media the slide holds. A native <video> plays with sound,
  // since the click that got here is a user gesture; if the browser still
  // refuses (iOS low-power mode, autoplay policy), it retries muted so the
  // video moves rather than sitting on its poster. A hosted YouTube/Vimeo
  // iframe has no such gesture inheritance, so it is reloaded with
  // autoplay=1&mute=1 - muted is the only form those players will honour.
  function playGallerySlide(slide) {
    if (!slide) return;
    const video = slide.querySelector("video");
    if (video) {
      const attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(() => {
          video.muted = true;
          const retry = video.play();
          if (retry && retry.catch) retry.catch(() => {});
        });
      }
      return;
    }
    const frame = slide.querySelector("iframe");
    if (frame && frame.src && !/[?&]autoplay=1/.test(frame.src)) {
      const join = frame.src.indexOf("?") === -1 ? "?" : "&";
      frame.src = frame.src + join + "autoplay=1&mute=1";
    }
  }

  // Media id -> slide index, so a variant's media can be resolved without
  // assuming media.id equals the legacy image id.
  function galleryIndexForMediaId(mediaId) {
    if (!mediaId) return null;
    const slide = document.querySelector(`[data-gallery-main] [data-media-id="${mediaId}"]`);
    return slide ? slide.getAttribute("data-index") : null;
  }
  document.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
    thumb.addEventListener("click", () => activateGalleryIndex(thumb.getAttribute("data-gallery-thumb"), true));
  });

  /* ---------- PDP: gallery "view all" thumbs reveal ---------- */
  document.querySelectorAll("[data-gallery-viewall]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const rack = btn.closest("[data-gallery-thumbs]");
      if (!rack) return;
      rack.querySelectorAll(".x-pdp__thumb--extra").forEach((el) => el.removeAttribute("hidden"));
      btn.remove();
    });
  });

  /* ---------- Product card: quick add-to-cart ---------- */
  // Delegated, because grids append more cards as you scroll. The card itself
  // is one big <a> to the PDP, so the click has to be stopped from reaching
  // the anchor's navigate-on-click as well as from doing anything of its own.
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-pcard-atc]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const id = btn.getAttribute("data-variant-id");
    if (!id || btn.disabled) return;
    addItemsToCart([{ id: id, quantity: 1, properties: {} }], btn);
  });

  /* ---------- PDP: quantity stepper in the buy form ---------- */
  document.querySelectorAll("[data-form-qty-decrease], [data-form-qty-increase]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const input = btn.parentElement.querySelector("[data-form-qty-input]");
      if (!input) return;
      const cur = parseInt(input.value, 10) || 1;
      input.value = btn.hasAttribute("data-form-qty-increase") ? cur + 1 : Math.max(1, cur - 1);
    });
  });

  /* ---------- PDP: variant swatches ---------- */
  const productJsonEl = document.querySelector("[data-product-json]");
  if (productJsonEl) {
    const variants = JSON.parse(productJsonEl.textContent);
    const variantMediaEl = document.querySelector("[data-variant-media-json]");
    let variantMedia = {};
    if (variantMediaEl) {
      try { variantMedia = JSON.parse(variantMediaEl.textContent); } catch (e) { variantMedia = {}; }
    }
    const optionButtons = document.querySelectorAll("[data-option-value-btn]");
    const selected = {};
    optionButtons.forEach((btn) => {
      if (btn.classList.contains("is-selected")) selected[btn.getAttribute("data-option-index")] = btn.getAttribute("data-option-value-btn");
    });

    function findVariant(sel) {
      return variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3];
        return Object.keys(sel).every((i) => opts[i] === sel[i]);
      });
    }

    // §22.2 - unavailable combinations are shown, disabled and struck, never hidden
    function markAvailability() {
      optionButtons.forEach((btn) => {
        const idx = btn.getAttribute("data-option-index");
        const probe = Object.assign({}, selected);
        probe[idx] = btn.getAttribute("data-option-value-btn");
        const match = findVariant(probe);
        btn.classList.toggle("is-unavailable", !match || !match.available);
      });
    }

    function applySelection() {
      const match = findVariant(selected);
      if (!match) return;
      const idInput = document.querySelector("[data-variant-id]");
      if (idInput) idInput.value = match.id;
      // Switch the big preview + thumb rail to this variant's own media. The
      // variant->media map rendered in product.liquid is authoritative; the
      // legacy featured_image id is only a fallback for older media payloads.
      let mediaIdx = galleryIndexForMediaId(variantMedia[match.id]);
      if (mediaIdx === null && match.featured_image) mediaIdx = galleryIndexForMediaId(match.featured_image.id);
      if (mediaIdx !== null) activateGalleryIndex(mediaIdx);
      document.querySelectorAll("[data-price]").forEach((el) => { el.textContent = formatMoney(match.price); });
      const onSale = Boolean(match.compare_at_price && match.compare_at_price > match.price);
      const compareEl = document.querySelector("[data-compare-price]");
      if (compareEl) {
        if (onSale) compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.hidden = !onSale;
      }
      const discountEl = document.querySelector("[data-discount-badge]");
      if (discountEl) {
        if (onSale) {
          const pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
          discountEl.textContent = pct + "% off";
        }
        discountEl.hidden = !onSale;
      }
      document.querySelectorAll("[data-add-to-cart], [data-sticky-atc-btn]").forEach((btn) => {
        btn.disabled = !match.available;
        btn.classList.remove("is-added");
        const label = match.available ? "Add to cart" : "Sold out";
        btn.setAttribute("data-label-idle", label);
        setBtnLabel(btn, label);
      });
      // §29.2 - the URL carries the variant so a shared link opens the right one
      const url = new URL(window.location.href);
      url.searchParams.set("variant", match.id);
      history.replaceState({}, "", url);
      markAvailability();
    }
    function formatMoney(cents) {
      return "₹" + Math.round(cents / 100).toLocaleString("en-IN");
    }
    optionButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const idx = btn.getAttribute("data-option-index");
        selected[idx] = btn.getAttribute("data-option-value-btn");
        document.querySelectorAll(`[data-option-index="${idx}"]`).forEach((b) => {
          const on = b === btn;
          b.classList.toggle("is-selected", on);
          b.setAttribute("aria-pressed", on ? "true" : "false");
        });
        const label = document.querySelector(`[data-option-value="${idx}"]`);
        if (label) label.textContent = selected[idx];
        applySelection();
      });
    });
    markAvailability();
  }

  /* ---------- PDP: sticky mobile ATC bar (§22.2) ---------- */
  const stickyAtc = document.querySelector("[data-sticky-atc]");
  const realAtc = document.querySelector("[data-add-to-cart]");
  if (stickyAtc && realAtc && "IntersectionObserver" in window) {
    new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => { stickyAtc.hidden = en.isIntersecting; });
      },
      { rootMargin: "0px 0px -60px 0px" }
    ).observe(realAtc);

    const stickyBtn = stickyAtc.querySelector("[data-sticky-atc-btn]");
    if (stickyBtn) {
      stickyBtn.addEventListener("click", () => {
        // Submit the real form so engraving properties and quantity come along
        const form = realAtc.closest("form");
        if (form) form.requestSubmit ? form.requestSubmit(realAtc) : realAtc.click();
      });
    }
  }

  /* ---------- PDP: related products (Product Recommendations API) ---------- */
  const relatedHost = document.querySelector("[data-related-products]");
  if (relatedHost && relatedHost.dataset.url) {
    fetch(relatedHost.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        relatedHost.innerHTML = html;
        if (window.xRevealScan) window.xRevealScan(relatedHost);
      });
  }

})();
